export class PaginationTrackers {
  static readonly TRACKER_PAGINATION_PREV_CLICK = '[Pagination Controls] prev click';

  static readonly TRACKER_PAGINATION_NEXT_CLICK = '[Pagination Controls] next click';
}
